import { z } from 'zod';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX = /^[\d\s()+-]{7,20}$/;

export const emailSchema = z.string()
  .min(1, 'Email is required')
  .regex(EMAIL_REGEX, 'Invalid email format — must be like name@example.com');

export const phoneSchema = z.string()
  .min(1, 'Phone is required')
  .regex(PHONE_REGEX, 'Invalid phone format');

/** Auto-format phone number as user types */
export function formatPhoneNumber(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length <= 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/** Async MX validation (optional — gracefully degrades offline) */
export async function validateEmailMx(email: string): Promise<string | null> {
  if (!email.trim()) return null;
  if (!EMAIL_REGEX.test(email)) return 'Invalid email format — must be like name@example.com';
  const domain = email.split('@')[1];
  try {
    const res = await fetch(
      `https://cloudflare-dns.com/dns-query?name=${encodeURIComponent(domain)}&type=MX`,
      { headers: { Accept: 'application/dns-json' } }
    );
    if (!res.ok) return null;
    const data = await res.json();
    if (!data.Answer || data.Answer.length === 0) {
      return `No mail server found for "${domain}" — check the email address`;
    }
    return null;
  } catch {
    return null;
  }
}
